module.exports = __webpack_public_path__ + "img/faq.50188392.svg";